module.exports = __webpack_public_path__ + "img/Logo-BLM@2x.b650bc71.png";